module.exports = __webpack_public_path__ + "img/c-1.549a766e.png";